'use client';

import LegalDocument from '@/components/LegalDocument';

export default function TermsAndConditions() {
  return <LegalDocument documentPath="/legal/terms_en.md" />;
}